module.exports = __webpack_public_path__ + "static/media/argument1_pic1.daa71b76.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/argument1_pic1.jpg
 ** module id = 430
 ** module chunks = 0
 **/